import React from 'react';
import PropTypes from 'prop-types';
import { Link, TranslationProvider, useAnalytics } from '@resy/ui-kitchen';
import './BlogNavBlurb.scss';

const CLICK_LINK_EVENT = 'click link';

export default function BlogNavBlurb(props) {
  const {
    blogNavLinks: {
      cityName, links, slug, willAppendCity,
    },
  } = props;
  const Analytics = useAnalytics();

  const formatNavLink = (toAppend, url, slugToAppend) => {
    if (!toAppend || slugToAppend === null) return url;
    let appendCharacter = '?';
    if (url.includes('?')) {
      appendCharacter = '&';
    }
    return `${url}${appendCharacter}city=${slugToAppend}`;
  };

  const handleLinkClick = (title) => {
    let value = null;
    if (title === 'Global Dining Access') {
      value = 'right rail global dining access';
    } else if (title.includes('Offers from Amex')) {
      value = 'right rail exclusive offers';
    }
    if (value && Analytics?.event) {
      Analytics.event(CLICK_LINK_EVENT, {
        context: 'homepage',
        value,
      });
    }
  };

  const renderBlogNavLinkElements = () => {
    if (!links || !links.length) return null;

    return links.map((navLink) => (
      <Link
        className="blog-nav-link"
        key={`blog-nav-link-${navLink.title}`}
        href={formatNavLink(willAppendCity, navLink.url, slug)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => handleLinkClick(navLink.title)}
      >
        <span>{navLink.title}</span>
      </Link>
    ));
  };

  const renderHeader = () => {
    if (cityName) {
      return (
        <TranslationProvider translationKey="blog_nav_header" translationValues={{ cityName }}>
          <h2>{`Discover restaurants to love in ${cityName}.`}</h2>
        </TranslationProvider>
      );
    }

    return (
      <TranslationProvider translationKey="blog_nav_fallback_header">
        <h2>Discover restaurants to love.</h2>
      </TranslationProvider>
    );
  };

  const renderReadMore = () => (
    <Link
      aria-label={`Read more about ${cityName}`}
      href={!slug ? 'https://blog.resy.com' : `https://blog.resy.com/city/${slug}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <TranslationProvider translationKey="blog_nav_homepage_cta">
        <span>Read More ›</span>
      </TranslationProvider>
    </Link>
  );

  return (
    <div className="BlogNavBlurb">
      {renderHeader()}
      <TranslationProvider
        className="BlogNavBlurb__content"
        translationKey="blog_nav_blurb"
      >
        Be the first to know with Resy’s insider guides, deep dives on old standbys, and vital intel on all the latest and greatest new openings.
      </TranslationProvider>
      <div className="BlogNavBlurb--Links">
        {renderBlogNavLinkElements()}
        {renderReadMore()}
      </div>
    </div>
  );
}

BlogNavBlurb.propTypes = {
  blogNavLinks: PropTypes.shape({
    cityName: PropTypes.string,
    willAppendCity: PropTypes.bool,
    slug: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })),
  }),
};

BlogNavBlurb.defaultProps = {
  blogNavLinks: {
    cityName: null,
    willAppendCity: false,
    slug: null,
    links: null,
  },
};
